//config.js
// console.log(process.env)
var config = {
  localConfig: {
    baseurl: 'http://localhost:5001/',
    recaptcha: '6LcHCLUaAAAAAIlapTlcAH7JrEC0ci5y-wc4bt0l'
  },
  swarmLocalConfig: {
    baseurl: 'http://192.168.1.101:5001/',
    recaptcha: '6LcHCLUaAAAAAIlapTlcAH7JrEC0ci5y-wc4bt0l'
  },
  devConfig: {
    baseurl: 'https://api.keen-pike.88-208-243-178.plesk.page/',
    recaptcha: '6Ldv9GsiAAAAAAt7aL-to8r_zyk6bY7d0SWKN-fx'
  },
  prodConfig: {
    //prod url
    baseurl: 'https://api.crazy-lamarr.88-208-243-178.plesk.page/',
    recaptcha: '6Lf5y9QkAAAAAAkFaAx-iUaiOaj2j8xYkDlxnOAQ'
  },
  isonosProdConfig: {
    //prod url
    baseurl: 'http://192.168.2.2:5001/',
    recaptcha: '6Lf5y9QkAAAAAAkFaAx-iUaiOaj2j8xYkDlxnOAQ'
  },
  rancherProdConfig: {
    //rancher prod url
    baseurl: 'https://api.elomarkportal.com/',
    recaptcha: '6LfEhwgpAAAAAMeMEsXJItdwJgAqLd69rNlrDEIN'
  },
  getConfig: function () {
    switch (window.location.hostname) {
      case 'localhost':
        return this.localConfig;
      case '192.168.1.101':
        return this.swarmLocalConfig;
      case 'keen-pike.88-208-243-178.plesk.page':
        return this.devConfig;
      case 'crazy-lamarr.88-208-243-178.plesk.page':
        return this.prodConfig;
      case 'elomarkapp.com':
        return this.isonosProdConfig;
      case 'elomarkportal.com':
        return this.rancherProdConfig;
    }
  }
}

export default config;
